import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { Button, Grid, TextareaAutosize } from "@material-ui/core";
import Backbutton from "../../Backbutton";
import { Formik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core//MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ImageUploader from "react-images-upload";
import FormData from "form-data";
import { Typography, Box, Modal } from "@material-ui/core";
import Selects from "react-select";
import ReactCrop from 'react-image-crop'
import { CircularProgress } from '@material-ui/core';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let schema = yup.object({

  disclaimer_text: yup.string().required("Dsiclaimer text is required"),
});


function Settings({
  server,
  history,
  access_token,
  role,
}) {

  const [errortext, seterrortext] = useState("");
  const [disclaimer, setDisclaimer] = useState("");
  const [loading, setLoading] = useState("");
  const [onLoading, setOnLoading] = useState("");
  const [onDeletingOrders, setOnDeletingOrders] = useState(false);

  useEffect(() => {

    getDisclaimer();

  }, []);


  const getDisclaimer = () => {

    setLoading(true);

    fetch(
      global.backendUrl + "/api/get-disclaimer-text")
      .then((res) => res.json())
      .then((json) => {
        setDisclaimer(json.disclaimerText)
        setLoading(false);
      })
  };


  const deleteAllOrders = () => {

    setOnDeletingOrders(true);

    const requestOptions = {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + access_token
      }
    };

    fetch(global.backendUrl + '/api/user/delete-all-orders', requestOptions)
      .then(response => response.json())
      .then(data => deleteResponse(data.user));

    /* fetch(
       "https://arihant-backend.trikaradev.xyz/api/user/delete-all-orders")
       .then((res) => res.json())
       .then((json) => {
         setDisclaimer(json.disclaimerText)
         setLoading(false);
       })*/
  };

  const handleFieldChange = (e) => {

    if (e.target.name == 'disclaimer_text') {
      setDisclaimer(e.target.value);
    }
  }

  const deleteResponse = (e) => {

    setOnDeletingOrders(false);

    toast('Orders data has been cleared', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  const saveSettings = (values, resetForm) => {

    setOnLoading(true);

    const bodyParameters = {
      disclaimer_text: disclaimer,
    };

    const data = new FormData();

    Object.keys(bodyParameters).forEach((key) => {
      data.set(key, bodyParameters[key]);
    });

    const config = {
      headers: { Authorization: `Bearer ${access_token}` },
    };

    axios
      .post(server + "api/user/update-disclaimer", data, config)
      .then((response) => {
        setOnLoading(false);
        toast('Disclaimer updated', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        const errormessage = error.response.data.errors.alias[0];
        seterrortext(errormessage);
      });
  };

  return (

    <div className="grayBackgroundBox">

      <div className="card container" style={{ marginTop: -100 }}>

        <h1 style={{ marginBottom: 30 }}>Settings</h1>

        <Formik
          initialValues={{
            disclaimer_text: "",
          }}
          onSubmit={(values, { resetForm }) => {
            saveSettings(values, resetForm);
          }}
        >
          {({
            values,
            handleBlur,
            handleChange,
            handleSubmit,
            errors,
            touched,
            isSubmitting,
            isValid,
          }) => (
            <form className="container" onSubmit={handleSubmit}>


              <Grid container>
                <Grid item xs={12} md={6}>
                  <div>

                    <div className="row">

                      <div className="col-12 col-md-6 inputFieldContainer">
                        <TextField
                          id="standard-basic"
                          label="Disclaimer Text*"
                          name="disclaimer_text"
                          onChange={handleFieldChange}
                          onBlur={handleBlur}
                          value={disclaimer}
                          fullWidth
                        />

                      </div>
                    </div>
                  </div>
                </Grid>


              </Grid>
              <div style={{ textAlign: "left" }} className="text-center mt-5">
                <Button
                  className="formSubmit"
                  variant="contained"
                  type="submit"
                  color="primary"
                  style={{ backgroundColor: '#F05225' }}
                  disableElevation
                >
                  {onLoading ? <CircularProgress style={{ color: 'white' }} /> : "Save Settings"}

                </Button>
              </div>
            </form>
          )}
        </Formik>

        <hr style={{ marginTop: 50 }} />

        <h2 style={{ marginTop: 50, }}>Data reset actions</h2>
        <Button
          className="formSubmit"
          variant="contained"
          color="primary"
          style={{ backgroundColor: 'red', paddingTop: 10 }}
          onClick={() => {if(window.confirm('Are you sure to delete all orders? This action cannot be reverted')){ deleteAllOrders()};}} 
          
          disableElevation
        >
          {onDeletingOrders ? <CircularProgress style={{ color: 'white' }} /> : "Delete All Orders"}

        </Button>

      </div>

    </div>
  );
}

const mapStateToProps = (state) => ({
  server: state.auth.server,
  access_token: state.auth.access_token,
  role: state.auth.role[0],
});

export default connect(mapStateToProps, {})(Settings);